__turbopack_context__.v({
  "browser_fix": "styles-module-scss-module__NmMtba__browser_fix",
  "notification_card": "styles-module-scss-module__NmMtba__notification_card",
  "notification_header": "styles-module-scss-module__NmMtba__notification_header",
  "notification_modal": "styles-module-scss-module__NmMtba__notification_modal",
});
